var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUnitsDue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 20,
    viewBox: "0 0 24 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.1791 18.3438H4.01678V7.83398H2.9668V18.8689C2.9668 19.1588 3.20184 19.3939 3.49179 19.3939H20.7041C20.994 19.3939 21.2291 19.1588 21.2291 18.8689V7.83398H20.1791V18.3438Z",
    fill: "#5981E9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.2551 0.0661492C12.0964 -0.0220497 11.9036 -0.0220497 11.745 0.0661492L0 6.59587L0.510144 7.51356L12 1.12574L23.4899 7.51356L24 6.59587L12.2551 0.0661492Z",
    fill: "#5981E9"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.687 9.38965C15.9311 9.38965 16.1289 9.19181 16.1289 8.94775C16.1289 8.7037 15.9311 8.50586 15.687 8.50586C15.443 8.50586 15.2451 8.7037 15.2451 8.94775C15.2451 9.19181 15.443 9.38965 15.687 9.38965Z",
    fill: "#5981E9"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15.687 7.88965C15.9311 7.88965 16.1289 7.69181 16.1289 7.44775C16.1289 7.2037 15.9311 7.00586 15.687 7.00586C15.443 7.00586 15.2451 7.2037 15.2451 7.44775C15.2451 7.69181 15.443 7.88965 15.687 7.88965Z",
    fill: "#5981E9"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M14.187 7.88965C14.4311 7.88965 14.6289 7.69181 14.6289 7.44775C14.6289 7.2037 14.4311 7.00586 14.187 7.00586C13.943 7.00586 13.7451 7.2037 13.7451 7.44775C13.7451 7.69181 13.943 7.88965 14.187 7.88965Z",
    fill: "#5981E9"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M15.687 6.38965C15.9311 6.38965 16.1289 6.19181 16.1289 5.94775C16.1289 5.7037 15.9311 5.50586 15.687 5.50586C15.443 5.50586 15.2451 5.7037 15.2451 5.94775C15.2451 6.19181 15.443 6.38965 15.687 6.38965Z",
    fill: "#5981E9"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M10.2236 10.3958V8.82623H10.9736V9.80091C10.9736 9.94011 11.029 10.0738 11.1274 10.1722L12.186 11.2307L12.9284 10.4882L12.0236 9.58356V8.82637H12.4568C12.7467 8.82637 12.9818 8.59133 12.9818 8.30138V6.59335C12.9818 6.30341 12.7467 6.06836 12.4568 6.06836H9.08243C8.84933 6.06836 8.64413 6.22211 8.57858 6.4459L8.07879 8.15378C8.03229 8.31248 8.06334 8.48378 8.16249 8.61608C8.26164 8.74838 8.41734 8.82623 8.58263 8.82623H9.17363V16.4136C9.17363 16.7035 9.40867 16.9386 9.69862 16.9386H12.6597C12.9497 16.9386 13.1847 16.7035 13.1847 16.4136V13.5746C13.1847 13.4354 13.1294 13.3019 13.031 13.2033L10.2236 10.3958ZM9.47587 7.11835H11.9318V7.77624H10.9736H10.2236H9.28328L9.47587 7.11835ZM12.1347 15.8886H10.2236V11.8808L12.1347 13.7919V15.8886Z",
    fill: "#5981E9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnitsDue);
export default __webpack_public_path__ + "static/media/units_due.b823915369f89fdb95275fad6b11c5b8.svg";
export { ForwardRef as ReactComponent };